import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import { StoryElement } from "@quintype/components";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import SocialMediaShare from "../social-media-share";
import "./imagecaption.m.css";

function ImagewithCaption({ element, story }) {
  const [toggleSharing, setToggleSharing] = useState(false);

  const sharingHandler = () => {
    setToggleSharing(!toggleSharing);
  };

  useEffect(() => {
    if (window) {
      window.dataLayer.push({
        event: "photoStory"
      });
    }
  }, []);

  return (
    <>
      <div styleName="wrapper">
        <div styleName="share-icon">
          <button styleName="share" onClick={sharingHandler}>
            <SvgIconHandler type="shareicon" />
          </button>
          <div styleName="share-options">{toggleSharing && <SocialMediaShare story={story} />}</div>
        </div>
        <StoryElement story={story} element={element} imageWidths={[420, 1040, 1600]} imageDefaultWidth={1040} />
      </div>
      <p styleName="image-caption-text">
        {element.title} <span styleName="image-attribute">{element["image-attribution"]}</span>
      </p>
    </>
  );
}

ImagewithCaption.propTypes = {
  element: object,
  story: object
};

export default ImagewithCaption;
